const initBlock = function( $block ) {
	$block.find( '.js-contact-me' ).on( 'click', function() {
		const memberEmail = $( this ).data( 'member-email' );
		const memberName  = $( this ).data( 'member-name' );

		const $modal = $block.find( '#team-member-popup' );

		$modal.off( 'shown.bs.modal.contact' ).on( 'shown.bs.modal.contact', function() {
			const $hiddenFields = $modal.find( '.modal-team-member__form input[type="hidden"]' );

			$hiddenFields.eq( 0 ).val( memberEmail );
			$hiddenFields.eq( 1 ).val( memberName );
		} );
	} );
};

app.loadBlock( initBlock, 'about-member', '.section-about-member' );

if ( module.hot ) {
	module.hot.accept();
}
